// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"f796c6f8","400":"80364550","414":"ea2f139a","425":"f6b763b4","667":"11135f05","880":"3201bb9d"}[chunkId] + ".chunk.js";
};